import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Row,
  Col,
  Card,
  Spin,
  Alert,
} from 'antd';
import request from '../../../../../logic/utils/request';
import ImageUpload from './ImageUpload';
import ImageList from './list';

function Images(props) {
  const { showError, preloader } = props;
  const [images, setImages] = useState([]);
  const [maxImageSize, setMaxImageSize] = useState(10); // По умолчанию 10MB
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getImages = useCallback(async () => {
    setLoading(true);
    setError(null);
    preloader();
    try {
      const response = await Axios({
        method: 'get',
        url: '/api/images',
      });
      setImages(response.data);
    } catch (e) {
      const errorMessage = e.response?.data?.error || e.message || 'Ошибка при загрузке изображений';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
      preloader();
    }
  }, [showError, preloader]);

  const getServerParams = async () => {
    try {
      const newParams = await request('/server/api/officeparams/', 'get');
      const { data: { data: paramsData } } = newParams;
      paramsData.forEach((el) => {
        if (el.param === 'maxSizeImage') {
          // Преобразуем значение в число или используем значение по умолчанию
          setMaxImageSize(parseInt(el.value, 10) || 10);
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('e === ', e);
      // Если не удалось получить параметры, оставляем значение по умолчанию
    }
  };

  useEffect(() => {
    getImages();
    getServerParams();
  }, [getImages]);

  const uploadImage = async () => {
    // Изображение уже загружено, просто обновляем список
    getImages();
  };

  const deleteImage = async (id) => {
    setLoading(true);
    preloader();
    try {
      await Axios({
        method: 'delete',
        url: '/api/images',
        data: {
          id,
        },
      });
      getImages();
      toast.success('Изображение успешно удалено');
    } catch (e) {
      const errorMessage = e.response?.data?.text || e.message || 'Ошибка при удалении изображения';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
      preloader();
    }
  };
  const setShow = async (id) => {
    setLoading(true);
    preloader();
    try {
      await Axios({
        method: 'patch',
        url: '/api/images',
        data: {
          id,
        },
      });
      getImages();
      toast.success('Изображение обновлено');
    } catch (e) {
      const errorMessage = e.response?.data?.text || e.message || 'Ошибка при обновлении изображения';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
      preloader();
    }
  };

  return (
    <div>
      {error && (
        <Alert
          message="Ошибка"
          description={error}
          type="error"
          closable
          onClose={() => setError(null)}
          style={{ marginBottom: 16 }}
        />
      )}
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Card bordered={false}>
            <ImageUpload
              save={uploadImage}
              showError={showError}
              maxFileSize={maxImageSize}
              disabled={loading}
            />
          </Card>
        </Col>
        <Col span={16}>
          <Spin spinning={loading} tip="Загрузка...">
            <ImageList
              deleteImage={deleteImage}
              setShow={setShow}
              images={images}
              loading={loading}
            />
          </Spin>
        </Col>
      </Row>
    </div>
  );
}

export default Images;
